<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  @if (page === 'training') {
    <div i18n="@@TrainingMaterialDetails">Training Material Details</div>
  }
  @if (page === 'marketing') {
    <div i18n="@@MarketingMaterialDetails">Marketing Material Details</div>
  }
  @if (page === 'company') {
    <div i18n="@@externalaterialDetails">External Material Details</div>
  }
  <mat-icon (click)="closeDialog()" class="cursor" i18n-label="@@closeDialog" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <div class="cards-container">
    <mat-card class="icons-card mb-16">
      <mat-card-content class="d-flex">
        <mat-icon class="mr-10" color="accent" i18n-label="@@materialIcon" aria-label="Material Icon">insert_drive_file</mat-icon>
        <div class="ml-10 w-90">
          <div class="mb-12 mat-card-content-text mat-caption" matTooltip ellipsisTooltip>{{material?.name}}</div>
          <div class="d-flex align-items-center  mat-caption mb-10">
            <div class="mat-caption" matTooltip ellipsisTooltip>{{material?.description}}</div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <!-- <mat-card *ngIf="authService.getUserData().type === utils.userTypes.Distributor && page !== 'company'" class="used-on-mobile">
      <div i18n="@@useOnMobile" class="mat-subheading-2">Use on mobile</div>
      <mat-checkbox (change)="usedOnMobileToggle($event)" color="accent"></mat-checkbox>
    </mat-card> -->
    <mat-card class="material-card">
      <mat-card-content class="d-flex justify-content-between align-items-center">
        <div i18n="@@download" class="d-inline mat-card-content-text">Download material</div>
        <div class="mat-caption d-inline">
          <a (click)="downloadMyFileAndLog(material)" href="{{material?.path}}" target="_blank">
            <mat-icon class="cursor" i18n-label="@@downloadIcon" aria-label="Download Material">get_app</mat-icon>
          </a>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>